var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7C12.5 7.66304 12.2366 8.29893 11.7678 8.76777C11.2989 9.23661 10.663 9.5 10 9.5C9.33696 9.5 8.70107 9.23661 8.23223 8.76777C7.76339 8.29893 7.5 7.66304 7.5 7C7.5 6.33696 7.76339 5.70107 8.23223 5.23223C8.70107 4.76339 9.33696 4.5 10 4.5C10.663 4.5 11.2989 4.76339 11.7678 5.23223C12.2366 5.70107 12.5 6.33696 12.5 7Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66406 6.99935C2.9974 3.58518 6.11073 1.16602 9.9974 1.16602C13.8841 1.16602 16.9974 3.58518 18.3307 6.99935C16.9974 10.4135 13.8841 12.8327 9.9974 12.8327C6.11073 12.8327 2.9974 10.4135 1.66406 6.99935Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.5684d75cb73569c59803de4e15070dde.svg";
export { ForwardRef as ReactComponent };